import script from "./KakaoShare.vue?vue&type=script&setup=true&lang=ts"
export * from "./KakaoShare.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__